<template>
  <section class="club__pages">
    <h2  class="form-title">
      <span class="form-title__intro">{{ isExistingForm ? "Edit Club Page:" : "Create Club Page" }}</span>
    </h2>
    <div class="v-window-item main-body">
      <v-container fluid>
        <v-form v-model="valid" ref="formDetails" lazy-validation v-if="clubData">
          <v-layout row v-for="(option, index) in ClubFormData" :key="index">
            <v-flex
              mr-5
              class="section__container"
            >
              <label
                class="subheading_header"
                :for="option.name"
              >
                {{ option.name }}
              </label>
              <div v-if="option.name === 'documents'">
                <draggable
                  v-model="clubData.attributes[option.name]"
                  :group="clubData.attributes[option.name]"
                  @start="drag=true"
                  @end="drag=false"
                >
                  <div v-for="(document, index) in clubData.attributes[option.name]" :key="index">
                    <v-flex mr-2 mb-5 class="section__container draggable">
                      <v-icon class="draggable-item__handle-icon">open_with</v-icon>
                      <div v-for="(field, index) in option.fields" :key="index">
                        <label
                          class="label"
                          :for="field.name"
                          >
                            {{ field.label ?  field.label : field.name }}
                        </label>
                        <v-text-field
                          v-model="document[field.name]"
                          variant="solo"
                          flat
                          :rules="[rules.required]"
                          validate-on-blur
                        />
                      </div>
                      <v-btn 
                        @click.prevent="removeItem(index, clubData.attributes[option.name])"
                        class="image-editor__image-delete v-btn v-btn--depressed v-btn--small theme--light error"
                      > 
                        Remove
                      </v-btn>
                    </v-flex>
                  </div>
                </draggable>
                <v-btn @click.native="newDoc()">Add document</v-btn>
              </div>
              <div v-if="option.name === 'stadium'">
                <draggable
                  v-model="clubData.attributes[option.name]"
                  :group="clubData.attributes[option.name]"
                  @start="drag=true"
                  @end="drag=false"
                >
                  <div v-for="(stadium, index) in clubData.attributes[option.name]" :key="index">
                    <v-flex mr-2 mb-5 class="section__container draggable">
                      <v-icon class="draggable-item__handle-icon">open_with</v-icon>
                      <div v-for="(field, index) in option.fields" :key="index">
                        <v-layout row>
                          <v-flex
                            v-if="index % 2 === 0"
                            class="half left"
                          >
                            <label
                              class="label"
                              :for="field.name"
                            >
                              {{ field.label ?  field.label : field.name }}
                            </label>
                            <v-text-field
                              v-model="stadium[field.name]"
                              variant="solo"
                            flat
                            />
                          </v-flex>
                          <v-flex
                            v-else
                            class="half right"
                          >
                            <label
                              class="label"
                              :for="field.name"
                            >
                              {{ field.label ?  field.label : field.name }}
                            </label>
                            <v-text-field
                              v-model="stadium[field.name]"
                              variant="solo"
                            flat
                            />
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="half right mt-5">
                        <v-btn 
                          @click.prevent="removeItem(index, clubData.attributes[option.name])"
                          class="image-editor__image-delete v-btn v-btn--depressed v-btn--small theme--light error"
                        > 
                          Remove
                        </v-btn>
                      </div>
                    </v-flex>
                  </div>
                </draggable>
                <v-btn @click.native="newStadium()">Add stadium</v-btn>
              </div>
              <div v-else-if="option.name !== 'documents' && option.name !== 'stadium'">
                <v-layout
                  v-for="(item, i) in option.fields" :key="i"
                >
                  <label
                    class="label"
                    :for="item.name"
                    >
                      {{ item.label ?  item.label : item.name }}
                    <span class="recommended" v-if="item.recommended">
                      (recommended)
                    </span>
                    <span class="required" v-if="item.required">
                      *
                    </span>
                  </label>
                  <div v-if="option.name === 'kits' || option.name === 'contacts' && item.name !== 'directors'">
                    <div v-if="item.name == 'contacts' && option.name !== 'kits'">
                      <draggable
                        v-model="clubData.attributes[option.name][item.name]"
                        :group="clubData.attributes[option.name][item.name]"
                        :fallbackOnBody="true"
                        :options="{
                          ghostClass: 'ghost',
                          dragClass: 'sortable-drag',
                        }"
                        @start="drag=true"
                        @end="drag=false"
                      >
                      <div v-for="(contact, index) in clubData.attributes[option.name][item.name]" :key="index">
                        <v-flex mr-2 mb-5 class="section__container draggable">
                          <v-icon class="draggable-item__handle-icon">open_with</v-icon>
                          <div class="dragged_component" v-for="(value, index) in item.fields" :key="index">
                            <v-layout row>
                              <v-flex
                                v-if="index % 2 === 0"
                                class="half left"
                              >
                                <label
                                  class="label"
                                  :for="value.name"
                                >
                                  {{ value.label ?  value.label : value.name }}
                                </label>
                                <v-text-field
                                  v-if="item.inputType === 'text-field' && item.type !== 'array' || item.type !== 'object'"
                                  v-model="contact[value.name]"
                                  :type="item.inputType"
                                  variant="solo"
                                  flat
                                />
                              </v-flex>
                              <v-flex
                                v-else
                                class="half right"
                              >
                                <label
                                  class="label"
                                  :for="value.name"
                                >
                                  {{ value.label ?  value.label : value.name }}
                                </label>
                                <v-text-field
                                  v-if="item.inputType === 'text-field' && item.type !== 'array' || item.type !== 'object'"
                                  v-model="contact[value.name]"
                                  :type="item.inputType"
                                  variant="solo"
                                  flat
                                />
                              </v-flex>
                            </v-layout>
                          </div>
                          <v-btn 
                          @click.native="removeItem(index, clubData.attributes[option.name][item.name])"
                          class="image-editor__image-delete v-btn v-btn--depressed v-btn--small theme--light error"
                          >
                            Remove contact
                          </v-btn>
                        </v-flex>
                      </div>
                    </draggable>
                      <v-btn @click.native="newContact()" class="mb-5">Add contact</v-btn>
                    </div>
                    <div v-if="option.name === 'kits' && item.name !== 'contacts' && item.name !== 'directors'">
                      <div class="section-container">
                        <v-layout row v-for="(singleItem, i) in item.fields" :key="i">
                          <label
                            class="label"
                            :for="singleItem.name"
                          > {{ singleItem.label ? singleItem.label : singleItem.name }}</label>
                          <v-text-field
                            v-if="singleItem.inputType === 'text-field' && item.type !== 'array' || item.type !== 'object'"
                            v-model="clubData.attributes[option.name][item.name][singleItem.name]"
                            variant="solo"
                            flat
                          />
                          <v-flex 
                            v-if="singleItem.inputType === 'image'">
                              <ImageUploader
                                :title="'Kit Image'"
                                :widthOptionEnabled="false"
                                :mediaLibraryID="clubData.attributes[option.name][item.name][singleItem.name]"
                                @update="updateImage($event, item.name, singleItem.name, singleItem.imageKey)"
                                :desc="'<p>Recommended size:</p><p>square 320x320 with transparent background</p>'"
                              />
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.name == 'directors' && item.name !== 'contacts'">
                    <v-textarea 
                      v-if="item.type !== 'array' || item.type !== 'object'"
                      v-model="clubData.attributes[option.name][item.name]"
                    ></v-textarea>
                  </div>
                  <div v-if="option.name === 'club'">
                    <v-text-field
                      v-if="item.name === 'name' && 
                      item.inputType === 'text-field'
                      && item.inputType !== 'number' 
                      && item.type !== 'array' && item.type !== 'object'"
                      v-model="clubData.attributes[option.name][item.name]"
                      variant="solo"
                      flat
                      :rules="[rules.required]"
                      validate-on-blur
                    />
                    <v-text-field
                      v-else-if="item.inputType === 'text-field'
                      && item.inputType !== 'number' 
                      && item.type !== 'array' && item.type !== 'object'"
                      v-model="clubData.attributes[option.name][item.name]"
                      variant="solo"
                      flat
                      validate-on-blur
                    />
                    <v-select
                      v-else-if="item.inputType === 'number'"
                      :items="competitionsArray"
                      item-text="name"
                      item-value="value"
                      v-model="clubData.attributes[option.name][item.name]"
                      type="select"
                      variant="solo"
                      class="competition__filter"
                      flat
                      :rules="[rules.required]"
                      validate-on-blur
                    />
                    <v-text-field
                      v-else-if="item.inputType === 'email'"
                      v-model="clubData.attributes[option.name][item.name]"
                      :type="item.inputType"
                      :rules="emailRules"
                      variant="solo"
                      flat
                    />
                    <v-text-field
                      v-else-if="item.inputType === 'url'"
                      v-model="clubData.attributes[option.name][item.name]"
                      :type="item.inputType"
                      :rules="urlRules"
                      variant="solo"
                      flat
                    />
                    <v-switch
                      v-else-if="item.inputType === 'switch'"
                      v-model="clubData.attributes[option.name][item.name]"
                      :type="item.inputType"
                      variant="solo"
                      flat
                    />
                    <v-flex 
                      v-if="item.inputType === 'image'">
                      <ImageUploader
                        :title="'Club Crest Image'"
                        :widthOptionEnabled="false"
                        :mediaLibraryID="clubData.attributes[option.name][item.name]"
                        @update="updateCrestImage($event, item.name, item.imageKey)"
                        :desc="'<p>Recommended size:</p><p>square 320x320 with transparent background</p>'"
                      />
                    </v-flex>
                  </div>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>  
      <sticky-footer
        :errorMessage="errorMessage"
        :status="saveStatus"
        @buttonClicked="isExistingForm ? updateClubDetails() : saveForm()"
        :allowPreview="false"
      />
    </div>
  </section>
</template>

<script>
  import axios from "axios"
  import draggable from "vuedraggable"
  import StickyFooter from "../../components/Library/StickyFooter";
  import ImageUploader from "@/components/Library/ImageUploader";
  import schema from "./data/schema.json";
  
  export default {
    name: "ClubEdit",
  
    components: {
      StickyFooter,
      ImageUploader,
      draggable
    },

    props: {
      club: {
        type: Object
      },
      competitions: {
        type: Object
      }
    },
  
    data: () => ({
      api: `${process.env.VUE_APP_CLUBS_SINGLEAPI}`,
      createApi: `${process.env.VUE_APP_CLUBSAPI}`,
      clubId: null,
      comp: [],
      clubData: {},
      saveError: "",
      saveStatus: "needsSaving",
      errorMessage: "",
      ClubFormData: {},
      valid: false,
      visible: "",
      isExistingForm: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      emailRules: [
        value => !value || /.+@.+/.test(value) || "Email must be valid"
      ],
      urlRules: [
        value => !value || /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(:\d+)?(\/.*)?$/.test(value) || "URL must be valid"
      ],
      competitionsData: null,
      competitionsArray: [
        { name: "English Football League - Championship", value: 10 },
        { name: "English Football League - One", value: 11 },
        { name: "English Football League - Two", value: 12 }
      ]
    }),

    mounted() {
      this.clubData = {
        type: null,
        id: null,
        attributes: {
          documents: [],
          club: {
            name: ""
          },
          stadium: [],
          contacts: {
              contacts: []
          },
          kits:{
            away:{
                socksText: "",
                kitImage: ""
            },
            goalKeeperAway: {
                socksText: "",
                kitImage: ""
            },
            goalKeeperHome: {
                socksText: "",
                kitImage: ""
            },
            goalKeeperThird: {
                socksText: "",
                kitImage: ""
            },
            home: {
                socksText: "",
                kitImage: ""
            },
            third: {
                socksText: "",
                kitImage: ""
            }
          }
        }
      }
      this.ClubFormData = schema
      if (this.$route.path === "/club/create") {
        this.isExistingForm = false
      } else {
        this.isExistingForm = true
        this.getSingleClubDetails()
        this.comp = this.competitions
      }
      
    },
    methods: {
      removeEmptyStrings(obj) {
        if (Array.isArray(obj)) {
          return obj.map(this.removeEmptyStrings);
        } else if (typeof obj === "object" && obj !== null) {
        return Object.fromEntries(
          Object.entries(obj)
            .map(([key, value]) => {
              return [key, this.removeEmptyStrings(value)];
            })
            .filter(([key, value]) => value !== "" && value !== null && value !== undefined)
          );
        }
        return obj;
      },

      saveForm() {
        this.saveStatus = "saving";
        this.errorMessage = "";
        if (this.$refs.formDetails.validate()) {
            this.$getCurrentUserJwToken().subscribe((jwt) => {
            axios({
                method: "POST",
                url: `${this.createApi}/pages`,
                headers: { Authorization: jwt },
                data: {
                  data: this.removeEmptyStrings(this.clubData)  
                },
            })
                .then((response) => {
                this.saveStatus = "saved";
                if (response.status === 200) {
                    this.$router.push({
                      path: "/club-pages"
                    })
                  }
                })
                .catch((error) => {
                console.error("Problem creating club pages", error);
                this.saveStatus = "needsSaving";
                this.errorMessage = "Problem creating club pages", error;
                });
            });
          } else {
              this.errorMessage = "Certain entries are invalid or required";
              this.saveStatus = "needsSaving";
              console.error("Problem saving club pages", this.errorMessage);
          }
      },
      
      getSingleClubDetails() {
        this.$store.commit("startLoading");
        this.clubId = this.$route.params.id
        this.$getCurrentUserJwToken().subscribe((jwt) => {
          axios({
            method: "GET",
            url: `${this.api}/${this.clubId}`,
            headers: { Authorization: jwt },
          })
          .then((response) => {
            this.clubData = response.data.data
            this.$store.commit("completeLoading");
          })
          
          .catch(e => {
              console.log("Unable to load teams:", e);
          })
        })
      },

      updateClubDetails() {
        this.saveStatus = "saving";
        this.errorMessage = "";
        const updatedData = 
        {
          data: {
            id: this.clubId,
            type: this.clubData.type,
            attributes: {
              documents: this.clubData.attributes.documents,
              club: this.clubData.attributes.club,
              stadium: this.clubData.attributes.stadium,
              contacts: this.clubData.attributes.contacts,
              kits: this.clubData.attributes.kits
            } 
          },
        }
        if (this.$refs.formDetails.validate()) {
        this.$getCurrentUserJwToken().subscribe((jwt) => {
          axios({
              method: "PATCH",
              url: `${this.api}/${this.clubId}`,
              headers: { Authorization: jwt },
              data: this.removeEmptyStrings(updatedData)
          })
          .then((response) => {
            this.saveStatus = "saved";
          }).catch((err) => {
            this.errorMessage = "Certain entries are invalid or required";
            this.saveStatus = "needsSaving";
            console.error("Problem saving club pages", this.errorMessage);
          })
        });
      } else {
          this.errorMessage = "Certain entries are invalid or required";
          this.saveStatus = "needsSaving";
          console.error("Problem saving club pages", this.errorMessage);
        }
      },

      newDoc() {
        this.clubData.attributes.documents.push({
          name: "",
          url: "",
        })
      },
      newStadium() {
        this.clubData.attributes.stadium.push({
          teamName: "",
          stadiumName: "",
          capacity: "",
          pitchDimensions: "",
          address: ""
        })
      },
      newContact() {
        this.clubData.attributes.contacts.contacts.push({
          name: "",
          emailAddress: "",
          position: "",
          phoneNumber: ""
        })
      },

      removeItem(index, item) {
        item.splice(index, 1)
      },
      
      updateImage(payload, target, file, key ) {
        this.clubData.attributes.kits[target][file] = payload.mediaLibraryID;
        this.clubData.attributes.kits[target][key] = payload.imageKey;
      },
      
      updateCrestImage(payload, target, key ) {
        this.clubData.attributes.club[target] = payload.mediaLibraryID;
        this.clubData.attributes.club[key] = payload.imageKey;
      },

    },
  };
  
</script>

<style lang='scss'>
 .draggable-item {
    transition: all 0.5s, opacity 0.2s;

    &__handle-icon {
      cursor: pointer;
      padding-right: 20px;
      position: absolute;
      top: 0;
      left: 0;

    }
  }
  .form-section {
    border: 1px solid #ccc;
    border-radius: 2px;
    padding: 16px 16px 8px;
    margin-bottom: 16px;
    background-color: #fff;
  }
  
  .form-title {
    border-bottom: 1px solid #67247c;
    background-color: #fff;
    color: #24002f;
    padding: 0 16px;
    font-weight: 500;
  
    @media screen and (min-width: 701px) {
      padding: 0 52px 16px;
    }
  
    &__intro {
      opacity: 0.7;
    }
  }

  .label {
    text-transform: capitalize;

    span {
      &.recommended {
        text-transform: lowercase;
        font-size: 12px;
      }

      &.required {
        color: red;
      }
    }
  }

  .half {
    width: 49%;

    &.left {
      float: left
    }

    &.right {
      float: right;
    }
  }

  .form {
    &__meta {
      display: flex;
      flex-direction: column;
    }
  }
  
  .form-builder-button {
    margin: 8px 0;
  }
  
  .add-address {
    align-self: flex-end;
    margin-bottom: 8px;
  }
  
  table {
    th {
      text-align: left;
      font-weight: normal;
    }
    .v-text-field__details {
      display: none;
    }
  }
  
  .form-builder-wrapper {
    min-width: 50%;
    width: 50%;
    padding-right: 16px;
    border-right: 1px dashed #ccc;
  
    &__header {
      display: flex;
      justify-content: space-between;
    }
    &--alt {
      width: 50%;
    }
  }
  


.subheading_header {
  margin: 35px 0 20px;
  padding: 0;
  color: #67247C;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  text-transform: capitalize;
  position: absolute;
  left: 5px;
  top: -63px;

  &__closed {
    border-bottom: 1px solid $lightgrey;
    padding-bottom: 12px;
  }
  &:hover {
    cursor: pointer;
  }

  &__label {
    position: relative;
    top: -2px;
    margin: 0 0 0 8px;
    padding: 4px 8px;
    color: #67247C;
    font-size: 12px;
    font-weight: 400;
    background-color: #E6E8F1;
    border-radius: 4px;
  }
}

.dropdown {
    label {
        display: none;
    }
}

.status-icon {
    position: absolute;
    top: 0;
    right: 0;
}

.sub__container {
  width: 100%;
  position: relative;
}

.club__pages {
  .section__container {
    margin: 0 0 70px;
    padding: 35px 35px;
    background-color: #FFFFFF;
    border: 1px solid #DFE3E9;
    border-radius: 4px;
    overflow: hidden;

    &.draggable {
      cursor: move;
      position: relative;
    }
  }
  .v-text-field {
    input {
      padding: 24px 5px;
      max-width: 100%;
      border: 1px solid #ccc;
      border-radius: 4px;
    }

    .v-input__control {
      .v-input__slot {
        &:before {
          border-style: none;
        }
      }
    }
  }

  .v-select__selections {
    input {
      padding: 24px 5px;
      max-width: 100%;
      border: none;
      border-radius: 0;
    }
  }


  .v-select__slot {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
  }

  .layout {
    display: block;
    position: relative;
  }
  .v-textarea {
    textarea{
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 5px;
    }
  }

  .theme--light {
    &.v-text-field--solo {
      > .v-input__control {
        > .v-input__slot {
          border: none;
          padding: 0;
        }
      }
    }

  }  
}

</style>
